import React from 'react';
import {useField} from 'formik';
import {Input} from '../../../../../../../form/form.jsx';

const Mail = () => {
  const [field, meta, helpers] = useField('mail');

  const {error, touched} = meta;
  const {setValue} = helpers;

  const isValid = !(error && touched);

  return (
    <Input
      {...field}
      type="email"
      placeholder="Эл. почта"
      isMin
      isValid={isValid}
      onChange={value => setValue(value.toLowerCase())}
    />
  );
};

export default Mail;
